<template>
    <a-collapse v-model:activeKey="rightMenuActive" accordion title="Camadas" :expand-icon-position="'end'" class="floating-menu-container right-menu" :style="panelStyle" v-show="!isPreviewMode">
        <a-collapse-panel key="1">
            <template #header>
                <span id="right-menu-title" v-if="rightMenuActive"><i class="fa fa-layer-group" style="color:#003366;" /> Camadas e Mapas</span>
                <span id="right-menu-title" v-else><i class="fa fa-layer-group" style="color:#003366;" /></span>
            </template>

            <div class="menu-content" id="layer-panel-content">
                <QueryConstructor
                    v-if="!props.isMapEditor"
                    :map-layers="mapLayers"
                    :module-selected="moduleSelected"
                    :layer-registration-context="layerRegistrationContext"
                />

                <div v-if="showModuleSelector" class="basemap-selector" style="width: 100%;">
                    <label style="color:#003366;"><i class="fa fa-layer-group" style="color:#003366;" /> Grupos:</label>
                    <a-select
                        ref="select"
                        v-model:value="moduleSelected"
                        style="width:100%"
                        @change="selectModule"
                        :disabled="props.disableChange"
                        :title="props.disableChange ? 'Impossível selecionar módulo com outros itens abertos' : 'Selecionar módulo'"
                    >
                        <a-select-option v-for="(value, key) in modules" :key="key" :value="key">{{ key }}</a-select-option>
                    </a-select>
                </div>

                <div class="layers-list-container" :style="layersListStyle">
                    <div v-if="mapLayers.length === 0" class="h-100 d-flex justify-content-center align-items-center">
                        <a-empty>
                            <template #description>
                              <span>Não há camadas para ver aqui...</span>
                            </template>
                            <a-button type="primary" size="small" href="/maps/layers">Menu de Camadas</a-button>
                        </a-empty>
                    </div>
                    <div v-for="(layer, index) in mapLayers" :key="layer.ol_uid" class="layer-item" :class="{ dirty: layer.get('isDirty') }" :ref="el => layerRefs[index] = el">
                        <div class="layer-item-top">
                            <div class="w-100 d-flex justify-content-between">
                                <span :title="layer.get('isDirty') ? 'Alterações não salvas nesta camada.' : ''" style="font-size: 13px; font-weight: bold; padding-bottom: 5px; text-align:left">
                                    {{ layer.get('name') ?? layer.get('title') }}
                                    <small v-if="layer.get('isDirty')" style="color: #dc3545;">(Pendente)</small>
                                </span>

                                <a-tooltip title="Ver FAQ relacionado" v-if="layer.get('actions')?.faq" :mouse-leave-delay="0">
                                    <a-button size="small" shape="circle" @click="layer.get('actions')?.faq()" type="primary" class="btn-info">
                                        <i class="fa fa-question" />
                                    </a-button>
                                </a-tooltip>
                            </div>

                            <div class="d-flex align-items-center justify-content-between w-100">
                                <div class="layer-actions">
                                    <a-tooltip :title="layer.getVisible() ? 'Ocultar camada' : 'Mostrar camada'" :mouse-leave-delay="0">
                                        <a-button @click="changeVisibility(layer)" type="primary" :class="{ 'btn-active': layer.getVisible() }" class="btn-dark">
                                            <i v-if="layer.getVisible()" class="fa fa-eye" />
                                            <i v-else class="fa fa-eye-slash" />
                                        </a-button>
                                    </a-tooltip>

                                    <a-tooltip title="Tabela de Atributos" :mouse-leave-delay="0">
                                        <a-button @click="openDataTable(layer)" type="primary" class="btn-info">
                                            <i class="fa fa-table" />
                                        </a-button>
                                    </a-tooltip>

                                    <a-tooltip title="Exportar camada" v-if="layer.get('isMultifinalitario')" :mouse-leave-delay="0">
                                        <a-button @click="layer.get('actions')?.export()" type="primary" class="btn-info">
                                            <i class="fa-solid fa-download" />
                                        </a-button>
                                    </a-tooltip>

                                    <a-tooltip title="Configurar Rótulos (Textos)" v-if="layer.get('isMultifinalitario') || !!props.isMapEditor" :mouse-leave-delay="0">
                                        <a-button @click="openLabelSetup(layer)" type="primary" class="btn-warning">
                                            <i class="fa fa-font" />
                                        </a-button>
                                    </a-tooltip>

                                    <a-tooltip title="Ver legenda da camada" v-if="!!props.isMapEditor" :mouse-leave-delay="0">
                                        <a-button @click="$emit('open-legend', layer)" type="primary" style="background-color: #8e44ad; border-color: #8e44ad;" title="Ver Legenda da Camada">
                                            <i class="fa fa-list-ul" />
                                        </a-button>    
                                    </a-tooltip>

                                    <a-tooltip title="Notificar" v-if="layer.get('isMultifinalitario')" :mouse-leave-delay="0">
                                        <a-button @click="layer.get('actions')?.notification()" type="primary" class="btn-warning">
                                            <i class="fa-solid fa-bell" />
                                        </a-button>
                                    </a-tooltip>
                                </div>

                                <div class="d-flex justify-content-end">
                                    <a-tooltip :title="'Opacidade da camada: ' + Math.round(layer.getOpacity() * 100) + '%'" :mouse-leave-delay="0">
                                        <input type="range" min="0" max="1" step="0.05" :value="layer.getOpacity()" @input="(e) => onLayerOpacityInput(layer, e)" @change="emitLayerData()" style="width: 70%;" />
                                    </a-tooltip>
                                </div>
                            </div>
                        </div>

                        <div class="h-auto flex flex-column align-items-center">
                            <a-tooltip title="Subir camada" :mouse-leave-delay="0">
                                <a-button
                                    class="p-1"
                                    @click="moveLayer(index, 'up')"
                                    title="Mandar para cima"
                                    :disabled="props.disableChange"
                                >
                                    <CaretUpOutlined style="margin: 0 !important" />
                                </a-button>
                            </a-tooltip>
                            <a-tooltip title="Descer camada" :mouse-leave-delay="0">
                                <a-button
                                    class="p-1"
                                    @click="moveLayer(index, 'down')"
                                    title="Mandar para baixo"
                                    :disabled="props.disableChange"
                                >
                                    <CaretDownOutlined style="margin: 0 !important" />
                                </a-button>
                            </a-tooltip>
                        </div>
                    </div>
                </div>

                <div class="basemap-selector" style="width: 100%;" v-if="rasterLayers.length > 0">
                    <label style="color:#003366;"><i class="fa fa-image" /> Camada Raster:</label>
                    <a-select
                        v-model:value="rasterLayersSelected"
                        mode="multiple"
                        style="width: 100%"
                        placeholder="Selecionar camadas"
                        :max-tag-count="0"
                        :options="rasterLayers"
                        @change="onSelectRasterLayer"
                    >
                        <template #maxTagPlaceholder="omittedValues">
                            <span>
                                {{ omittedValues.length }}
                                {{ omittedValues.length === 1 ? 'selecionado' : 'selecionados' }}
                            </span>
                        </template>

                        <template #option="option">
                            <div>
                                {{ option.label }}
                            </div>
                        </template>
                    </a-select>
                </div>

                <div class="basemap-selector" style="width: 100%;">
                    <label style="color:#003366;"><i class="fa fa-globe" /> Camada de Fundo:</label>
                    <a-select
                        ref="select"
                        v-model:value="basemapSelected"
                        style="width:100%"
                        @change="selectBaseMap"
                        :disabled="props.disableChange"
                        :title="props.disableChange ? 'Impossível selecionar camada base com outros itens abertos' : 'Selecionar camada de base'"
                    >
                        <a-select-option value="none">Nenhum</a-select-option>
                        <a-select-option value="g_road_wo_building">Google Ruas sem construção</a-select-option>
                        <a-select-option value="g_road">Google Ruas</a-select-option>
                        <a-select-option value="g_sat">Google Satélite</a-select-option>
                        <a-select-option value="g_sat_e_roads">Google Satélite e Ruas</a-select-option>
                        <a-select-option value="g_terrain">Google Terreno</a-select-option>
                        <a-select-option value="g_terrain_e_roads">Google Terreno e Ruas</a-select-option>
                        <a-select-option value="esri_sat">ESRI Satélite</a-select-option>
                        <a-select-option value="carto_light">CartoDB Claro</a-select-option>
                        <a-select-option value="osm">OpenStreetMap (Ruas)</a-select-option>
                    </a-select>
                </div>
            </div>
        </a-collapse-panel>
    </a-collapse>

    <a-modal v-model:open="showTableDialog" width="90%" :footer="null" :closable="false" :bodyStyle="{ padding: '0' }">
        <a-spin :spinning="isTableLoading" size="large" tip="Processando dados da tabela...">
            <div style="padding: 20px;">
                <h3 id="table-title" style="display: flex; justify-content: space-between; align-items: center; margin-top: 0;">
                    <span><i class="fa fa-table" /> Dados: {{ selectedLayer.get('name') }}</span>
                    <a-button @click="showTableDialog = false" shape="circle" danger><i class="fa fa-times" /></a-button>
                </h3>
                <a-button size="large" :disabled="!tableFiltered || !(filterResults > 0)" @click="openTableExport" class="btn-success" :style="!tableFiltered || !(filterResults > 0) ? {opacity: 0.5} : {}" style="margin-bottom: 20px; color: white; width: 100%;">
                    <i class="fa fa-magic" /> Criar Nova Camada com Resultados filtrados <span v-if="tableFiltered && filterResults > 0"> ({{ filterResults }} registros)</span>
                </a-button>

                <a-table
                    v-if="tableColumns.length > 0"
                    :key="selectedLayer.ol_uid"
                    :columns="tableColumns"
                    :data-source="dataSource?.data || []"
                    :loading="loading"
                    :pagination="pagination"
                    :row-key="record => record.key"
                    @change="handleTableChange"
                    :scroll="{ y: 500, x: 1000 }"
                    bordered
                />

                <a-empty v-else description="Sem dados para exibir" />
            </div>
        </a-spin>
    </a-modal>

    <a-modal v-model:open="showTableExportDialog" title="Estilizar Nova Camada a partir da Tabela" footer="">
        <label>Nome da Nova Camada:</label>
        <a-input v-model:value="tableExportData.name" style="margin-bottom: 10px;" />
        <div style="display: flex; gap: 15px; margin-bottom: 15px;">
            <div style="flex: 1;"><label>Cor (Fundo):</label><input type="color" v-model="tableExportData.fill" style="width: 100%; height: 35px; border:none; padding:0;" /></div>
            <div style="flex: 1;"><label>Cor (Borda):</label><input type="color" v-model="tableExportData.stroke" style="width: 100%; height: 35px; border:none; padding:0;" /></div>
        </div>
        <div class="modal-buttons" style="display: flex; justify-content: flex-end; gap: 10px;">
            <a-button @click="showTableExportDialog = false" type="primary" danger>Cancelar</a-button>
            <a-button @click="confirmTableExport" type="primary" class="btn-success">Criar Camada</a-button>
        </div>
    </a-modal>

    <a-modal v-model:open="showLabelSetupDialog" title="Configurar Rótulo da Camada" :footer="null">
        <div v-if="currentLabelLayer">
            <label style="font-weight: bold; display: block; margin-bottom: 5px;">Atributo para exibir (Texto):</label>
            <a-select :value="currentLabelLayer.get('labelField') || 'NONE'" @change="(val) => updateLabelProp('labelField', val)" style="width: 100%; margin-bottom: 15px;">
                <a-select-option value="NONE">-- Nenhum Texto --</a-select-option>
                <a-select-option v-for="attr in labelOptions" :key="attr.name" :value="attr.name">{{ attr.label }}</a-select-option>
            </a-select>

            <div style="display: flex; gap: 15px; margin-bottom: 15px;">
                <div style="flex: 1;">
                    <label style="font-weight: bold; display: block; margin-bottom: 5px;">Cor da Fonte:</label>
                    <input type="color" :value="currentLabelLayer.get('labelColor') || '#000000'" @change="(e) => updateLabelProp('labelColor', e.target.value)" style="width: 100%; height: 32px; border: 1px solid #ccc; border-radius: 4px; padding: 2px; cursor: pointer;" />
                </div>
                <div style="flex: 1;">
                    <label style="font-weight: bold; display: block; margin-bottom: 5px;">Tamanho (px):</label>
                    <input type="number" :value="currentLabelLayer.get('labelSize') || 12" @input="(e) => updateLabelProp('labelSize', parseInt(e.target.value))" min="8" max="72" :style="{width: '100%', height: '32px', padding: '4px 8px', border: '1px solid #ccc', borderRadius: '4px'}" />
                </div>
            </div>

            <label style="font-weight: bold; display: block; margin-bottom: 5px;">Tipo da Fonte:</label>
            <a-select :value="currentLabelLayer.get('labelFont') || 'Arial'" @change="(val) => updateLabelProp('labelFont', val)" style="width: 100%; margin-bottom: 20px;">
                <a-select-option value="Arial">Arial</a-select-option>
                <a-select-option value="'Times New Roman'">Times New Roman</a-select-option>
                <a-select-option value="Courier">Courier</a-select-option>
            </a-select>
            <div style="text-align: right;"><a-button @click="showLabelSetupDialog = false" type="primary" class="btn-success">Concluído</a-button></div>
        </div>
    </a-modal>
</template>

<script setup>
import {computed, h, onMounted, onUnmounted, ref, shallowRef, markRaw, watch} from "vue";
import {Tile} from "ol/layer";
import OSM from "ol/source/OSM";
import XYZ from "ol/source/XYZ";
import {Button, Input} from "ant-design-vue";
import {CaretDownOutlined, CaretUpOutlined, SearchOutlined} from "@ant-design/icons-vue";
import {usePagination} from 'vue-request';
import VectorSource from "ol/source/Vector";
import Feature from "ol/Feature";
import GeoJSON from "ol/format/GeoJSON";
import { geoJsonReadOptions } from '../../../../open-layers/projections.js';
import VectorLayer from "ol/layer/Vector";
import Style from "ol/style/Style";
import {Circle, Text} from "ol/style";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import LayerGroup from "ol/layer/Group";
import {openNotification} from "../../../../utils/utilities.js";
import QueryConstructor from "./QueryConstructor.vue";
import {addLayerToMapAndSwitcher, addLayerToMap, generateLayerStyle, registerLayerInCurrentModule, registerLayerStateListeners, getTableReference} from "../../../../open-layers/helpers";

const props = defineProps(['map', 'disableChange', 'layerSwitcherData', 'isMapEditor', 'defaultBaseMap']);
const emit = defineEmits(['update-layer-data', 'open-legend', 'action']);
const modules = shallowRef({});
const moduleSelected = ref('Padrão');
const basemapSelected = ref('none');
const baseLayerInfo = ref({});
const tableDescription = ref('');
const isPreviewMode = ref(false);
const isTableLoading = ref(false);
const showTableDialog = ref(false);
const showTableExportDialog = ref(false);
const showLabelSetupDialog = ref(false);
const tableFiltered = ref(false);
const tableExportData = ref({fill: '#000000', stroke: '#000000'});
const mapLayers = shallowRef([]);
const moduleViewOrders = shallowRef({});
const labelOptions = ref([]);
const tableColumns = ref([]);
const layerRefs = [];
const DEFAULT_BASEMAP_SOURCE = 'g_road_wo_building';
const currentLabelLayer = shallowRef(null);
const rightMenuActive = ref(null);
const rasterLayers = ref([]);
const rasterLayersSelected = ref([]);
const rasterLayerInstances = shallowRef([]);
const hiddenLayers = shallowRef([]);
const selectedLayer = ref(null);
const documentLayer = ref(null);
const imagesLayer = ref(null);
const filterResults = ref(0);
const tableFilters = ref({});
let mapRenderFrame = null;
const dirtyListenersRegistered = new WeakSet();
const mapViewportSize = ref({ width: 0, height: 0 });
let mapResizeObserver = null;
let addLayerToSwitcherListener = null;
let removeLayerFromSwitcherListener = null;

const showModuleSelector = computed(() => Object.keys(modules.value || {}).length > 1);

const panelWidthPx = computed(() => {
    const mapWidth = Number(mapViewportSize.value.width || 0);

    if (mapWidth <= 0) return 370;

    return Math.min(370, Math.max(180, Math.round(mapWidth * 0.42)));
});

const panelMaxHeightPx = computed(() => {
    const mapHeight = Number(mapViewportSize.value.height || 0);

    if (mapHeight <= 0) return 520;

    return Math.round(mapHeight * 0.85);
});

const menuContentMaxHeightPx = computed(() => {
    return Math.max(90, panelMaxHeightPx.value - 56);
});

const layersListMaxHeightPx = computed(() => {
    return Math.round(panelMaxHeightPx.value * 0.5);
});

const panelStyle = computed(() => ({
    width: rightMenuActive.value ? `${panelWidthPx.value}px` : 'fit-content',
    maxWidth: `${panelWidthPx.value}px`,
    maxHeight: `${panelMaxHeightPx.value}px`,
    overflow: 'hidden',
}));

const menuContentStyle = computed(() => ({
    maxHeight: `${menuContentMaxHeightPx.value}px`,
    overflowY: 'hidden',
}));

const layersListStyle = computed(() => ({
    width: '100%',
    overflowY: 'auto',
    height: `${layersListMaxHeightPx.value}px`,
    maxHeight: `${layersListMaxHeightPx.value}px`,
    minHeight: '80px',
    flex: '1 1 auto',
}));

const normalizeLayerName = (value) => String(value ?? '').trim().toLowerCase();

const getLayerDisplayName = (layer) => {
    if (!layer?.get) return '';
    return layer.get('name') || layer.get('title') || layer.get('layerName') || '';
};

const isBaseMapLayer = (layer) => {
    if (!layer?.get) return false;
    return Boolean(layer.get('baseLayer') || layer.get('baseLayerId'));
};

const shouldPreferLayer = (currentLayer, candidateLayer) => {
    if (!currentLayer) return true;
    if (!candidateLayer) return false;

    const currentId = currentLayer.get?.('id');
    const candidateId = candidateLayer.get?.('id');
    const currentIsFixed = currentId === undefined || currentId === null || currentId === '';
    const candidateIsFixed = candidateId === undefined || candidateId === null || candidateId === '';

    if (candidateIsFixed !== currentIsFixed) {
        return candidateIsFixed;
    }

    return false;
};

const buildUniqueLayerList = (layers = []) => {
    const uniqueLayers = [];
    const indexByName = new Map();

    layers.forEach((layer) => {
        const normalizedName = normalizeLayerName(getLayerDisplayName(layer));

        if (!normalizedName) {
            uniqueLayers.push(layer);
            return;
        }

        const existingIndex = indexByName.get(normalizedName);

        if (existingIndex === undefined) {
            indexByName.set(normalizedName, uniqueLayers.length);
            uniqueLayers.push(layer);
            return;
        }

        const existingLayer = uniqueLayers[existingIndex];
        if (shouldPreferLayer(existingLayer, layer)) {
            uniqueLayers[existingIndex] = layer;
        }
    });

    return uniqueLayers;
};

const getLayerIdentityKey = (layer) => {
    const id = layer?.get?.('id');
    if (id !== undefined && id !== null && id !== '') {
        return `id:${id}`;
    }

    const normalizedName = normalizeLayerName(getLayerDisplayName(layer));
    return normalizedName ? `name:${normalizedName}` : `uid:${layer?.ol_uid ?? Math.random()}`;
};

const requestMapRender = () => {
    if (mapRenderFrame !== null) return;

    mapRenderFrame = window.requestAnimationFrame(() => {
        mapRenderFrame = null;
        props.map?.render?.();
    });
};

const updateMapViewportSize = () => {
    const targetElement = props.map?.getTargetElement?.();
    const width = targetElement?.clientWidth ?? 0;
    const height = targetElement?.clientHeight ?? 0;

    mapViewportSize.value = { width, height };
};

const refreshLayerList = () => {
    mapLayers.value = [...mapLayers.value];
    requestMapRender();
};

const serializeLayerConfig = (layer) => {
    if (!layer) return null;

    return {
        id: layer.get?.('id'),
        visible: layer.getVisible?.(),
        opacity: layer.getOpacity?.(),
        zIndex: layer.getZIndex?.(),
    };
};

const serializeModulesConfig = (modulesConfig) => {
    return Object.fromEntries(
        Object.entries(modulesConfig || {}).map(([moduleName, layers]) => [
            moduleName,
            Array.isArray(layers)
                ? layers.map(serializeLayerConfig).filter(Boolean)
                : layers,
        ])
    );
};

const emitLayerData = () => {
    emit('update-layer-data', {
        moduleSelected: moduleSelected.value,
        modules: serializeModulesConfig(modules.value),
        moduleViewOrders: moduleViewOrders.value,
        rasterLayersSelected: [...rasterLayersSelected.value],
        source: 'layer-switcher',
        baseLayer: basemapSelected.value,
    });
};
const basemapSources = {
    'g_road_wo_building': new XYZ({url: 'http://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}', crossOrigin: 'anonymous', maxZoom: 19}),
    'g_road': new XYZ({url: 'http://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', crossOrigin: 'anonymous', maxZoom: 19}),
    'g_sat': new XYZ({url: 'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', crossOrigin: 'anonymous', maxZoom: 20}),
    'g_sat_e_roads': new XYZ({url: 'http://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}', crossOrigin: 'anonymous', maxZoom: 19}),
    'g_terrain': new XYZ({url: 'http://mt1.google.com/vt/lyrs=t&x={x}&y={y}&z={z}', crossOrigin: 'anonymous', maxZoom: 19}),
    'g_terrain_e_roads': new XYZ({url: 'http://mt1.google.com/vt/lyrs=p&x={x}&y={y}&z={z}', crossOrigin: 'anonymous', maxZoom: 19}),
    'esri_sat': new XYZ({url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', crossOrigin: 'anonymous', maxZoom: 19}),
    'carto_light': new XYZ({url: 'https://cartodb-basemaps-a.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png', crossOrigin: 'anonymous', maxZoom: 19}),
    'osm': new OSM(),
};
const basemapLayer = new Tile({source: basemapSources[DEFAULT_BASEMAP_SOURCE], properties: { baseLayerId: DEFAULT_BASEMAP_SOURCE },})

const applyBaseMap = (source, fallback = DEFAULT_BASEMAP_SOURCE) => {
    let normalizedSource = source;

    if (source !== null && source !== 'none' && !Object.prototype.hasOwnProperty.call(basemapSources, source)) {
        normalizedSource = Object.prototype.hasOwnProperty.call(basemapSources, fallback)
            ? fallback
            : DEFAULT_BASEMAP_SOURCE;
    }

    basemapSelected.value = normalizedSource;

    if (normalizedSource === null || normalizedSource === 'none') {
        basemapLayer.setVisible(false);
        basemapLayer.set('baseLayerId', null);
        return;
    }

    basemapLayer.setSource(basemapSources[normalizedSource]);
    basemapLayer.set('baseLayerId', normalizedSource);
    basemapLayer.setVisible(true);
};

/** API CALL (SERVER SIDE) */
const queryData = async (params) => {
    try {
        const res = (await axios.get('/api/maps/layers/table', {
            params: {...params, table: getTableReference(selectedLayer.value)}
        })).data.data

        tableDescription.value = res.description;
        filterResults.value = res.total;
        return res
    } catch (err) {
        openNotification('error', 'Erro ao buscar dados da tabela.');
        return {
            data: [],
            total: 0,
        }
    }
}

/** PAGINATION HOOK */
const {
    data: dataSource,
    run,
    loading,
    current,
    pageSize,
} = usePagination(queryData, {
    manual: true,
    pagination: {
        currentKey: 'page',
        pageSizeKey: 'limit',
    },
})

/** TABLE CHANGE (pagination, filters, sorter) */
const handleTableChange = (pag, filters, sorter) => {
    tableFiltered.value = Object.values(filters).some(value => value !== null && value !== undefined)
    tableFilters.value = cleanObject(filters)

    run({
        page: pag.current,
        limit: pag.pageSize,

        sortField: sorter?.field,
        sortOrder: sorter?.order,

        ...filters,
    })
}

/** PAGINATION UI */
const pagination = computed(() => ({
    total: dataSource.value?.total || 0,
    current: current.value,
    pageSize: pageSize.value,
    showSizeChanger: true
}))

const openDataTable = async (layer) => {
    showTableDialog.value = true;
    isTableLoading.value = true;
    tableFiltered.value = false;
    selectedLayer.value = layer;
    tableFilters.value = {};
    tableColumns.value = [];

    try {
        const res = (await axios.get(`/api/maps/layers/columns`, {
            params: { table: getTableReference(layer) }
        })).data.data

        tableColumns.value = res.map(col => ({
            title: col.label || col.name,
            dataIndex: col.name,
            key: col.name,
            sorter: true,
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
                return h('div', { style: 'padding: 8px' }, [
                    h(Input, {
                        value: selectedKeys[0],
                        placeholder: 'Filtrar...',
                        style: 'width: 188px; margin-bottom: 8px; display: block',

                        onChange: (e) => {
                            setSelectedKeys(e.target.value ? [e.target.value] : [])
                        },

                        onPressEnter: () => confirm(),
                    }),

                    h(Button, { size: 'small', type: 'text', style: 'width: 90px', onClick: () => clearFilters(), }, () => 'Limpar'),

                    h(Button, { type: 'primary', size: 'small', style: 'width: 90px; margin-left: 8px', icon: h(SearchOutlined), onClick: () => confirm(), }, () => 'Procurar'),
                ])
            }
        }))

        run({
            page: 1,
            limit: 50,
            ...layer.get('fixedFilters'),
        })
    } catch (err) {
        openNotification('error', 'Erro ao buscar colunas da tabela.');
        return { data: [] }
    } finally {
        isTableLoading.value = false;
    }
}

const cleanObject = (obj) => {
    return Object.fromEntries(
        Object.entries(obj).filter(
            ([_, v]) => v !== null && v !== undefined && v !== ''
        )
    )
}

const selectBaseMap = (e) => {
    applyBaseMap(e);
}

const selectModule = (e) => {
    moduleSelected.value = e

    syncMapLayers()
    emitLayerData()
}

const changeVisibility = (layer) => {
    layer.loading = true
    layer.setVisible(!layer.getVisible())

    if (layer.get('labelLayer') && !layer.get('labelLayer').get('ignored')) {
        layer.get('labelLayer').setVisible(layer.getVisible())
    }

    refreshDisplayedLayers()
    emitLayerData()

    layer.loading = false
}

const onLayerOpacityInput = (layer, event) => {
    const value = parseFloat(event?.target?.value)

    if (!Number.isFinite(value)) return

    layer.setOpacity(value)
    requestMapRender()
}

const ensureRasterLayersOnMap = () => {
    const collection = props.map.getLayers();

    rasterLayerInstances.value.forEach((layer, index) => {
        if (!collection.getArray().includes(layer)) {
            collection.insertAt(index + 1, layer);
        }
    });
};

const applyLayerStacking = (desiredLayers = []) => {
    basemapLayer.setZIndex(0);
    const rasterBaseZIndex = rasterLayerInstances.value.length;

    rasterLayerInstances.value.forEach((layer, index) => {
        layer.setZIndex(index + 1);
    });

    desiredLayers.forEach((layer, index) => {
        const geometryZIndex = rasterBaseZIndex + (desiredLayers.length - index);
        layer.setZIndex(geometryZIndex);

        const labelLayer = layer.get('labelLayer');
        if (labelLayer && !labelLayer.get('ignored')) {
            labelLayer.setZIndex(geometryZIndex + 0.5);
        }
    });

    if (documentLayer.value) {
        documentLayer.value.setZIndex(1000);
    }

    if (imagesLayer.value) {
        imagesLayer.value.setZIndex(1001);
    }
};

const onSelectRasterLayer = (selectedIds = []) => {
    rasterLayersSelected.value = [...selectedIds];

    ensureRasterLayersOnMap();

    rasterLayerInstances.value.forEach(layer => {
        layer.setVisible(rasterLayersSelected.value.includes(layer.get('id')));
    });

    applyLayerStacking(getDesiredLayers(moduleSelected.value || 'Padrão'));

    emitLayerData()
    requestMapRender()
}

const openTableExport = () => {
    if (filterResults === 0) return openNotification('warning', 'Nenhum dado filtrado.');
    tableExportData.value.name = `${selectedLayer.value.get('name')} - Filtrada`;
    showTableExportDialog.value = true;
};

const confirmTableExport = async () => {
    const { data: geojson } = await axios.get('/api/maps/layers/generate', {
        params: {...tableFilters.value, table: getTableReference(selectedLayer.value)}
    })

    const layer = addLayerToMap(
        geojson,
        tableExportData.value.name,
        tableExportData.value.stroke,
        tableExportData.value.fill,
        'NONE',
        {font: getTableReference(selectedLayer.value), fixedFilters: tableFilters.value}
    )

    registerLayerInCurrentModule(layer, layerRegistrationContext)

    openNotification('success', `Camada '${tableExportData.value.name}' criada com sucesso!`)
    showTableExportDialog.value = false
    showTableDialog.value = false
}

const newAddLayerToSystem = (data, name, stroke, fill, labelField, tableInfo = null) => {
    const isMain = name === 'Lotes' || name === 'Edificações';

    let features = [];
    if (Array.isArray(data) && data.length > 0 && data[0] instanceof Feature) {
        features = data;
    } else if (data) {
        const validGeometryTypes = ['Point', 'LineString', 'Polygon', 'MultiPoint', 'MultiLineString', 'MultiPolygon', 'GeometryCollection'];

        const cleanData = {
            ...data,
            features: data.features.filter((feature) => (
                feature?.type === 'Feature' &&
                feature?.geometry &&
                validGeometryTypes.includes(feature.geometry.type)
            ))
        };

        features = new GeoJSON().readFeatures(cleanData, geoJsonReadOptions());

        features.forEach((feature, index) => {
            if (feature.getId() === null) feature.setId(`${name}-${index}`);
        });
    }

    const source = new VectorSource({ features: features });

    const layer = markRaw(new VectorLayer({
        source: source,
        style: generateLayerStyle(createDefaultBaseStyle(stroke, fill), labelField),
        visible: isMain || !isMain
    }));
    layer.set('name', name);
    layer.set('isMain', isMain);
    layer.set('isDirty', false);
    layer.set('strokeColor', stroke);
    layer.set('fillColor', fill);
    layer.set('labelField', labelField);
    layer.set('labelColor', '#000000');
    layer.set('labelSize', 12);
    layer.set('labelFont', 'Arial');

    if (!!tableInfo) {
        layer.set('font', tableInfo.font);
        layer.set('fixedFilters', tableInfo.fixedFilters);
    }

    addLayerToMapAndSwitcher(props.map, layer, {
        moduleName: moduleSelected.value,
        position: 'top',
    });

    return layer;
};

const normalizeStyles = (styleValue) => {
    if (!styleValue) return [];
    return Array.isArray(styleValue) ? styleValue.filter(Boolean) : [styleValue];
};

const stripTextFromStyle = (style) => {
    if (!style) return null;
    if (typeof style.clone !== 'function') return style;

    const clonedStyle = style.clone();
    clonedStyle.setText(undefined);
    return clonedStyle;
};

const createLabelText = (feature, labelField, labelColor, labelSize, labelFont) => {
    const dynamicLabelField = feature.get('customLabelField') || labelField;

    if (!dynamicLabelField || dynamicLabelField === 'NONE') return null;

    const value = feature.get(dynamicLabelField);
    if (value === undefined || value === null || value === '') return null;

    return new Text({
        text: String(value),
        font: `bold ${labelSize}px ${labelFont}`,
        fill: new Fill({ color: labelColor }),
        stroke: new Stroke({ color: '#fff', width: 3 }),
        overflow: true
    });
};

const createDefaultBaseStyle = (stroke, fill) => {
    return function(feature) {
        const featureFill = feature.get('color') || fill;
        const featureStroke = feature.get('strokeColor') || stroke;

        return new Style({
            fill: new Fill({ color: featureFill }),
            stroke: new Stroke({ color: featureStroke, width: 2 }),
            image: new Circle({ radius: 5, fill: new Fill({ color: featureFill }) })
        });
    };
};

const openLabelSetup = async (layer) => {
    currentLabelLayer.value = layer;

    labelOptions.value = (await axios.get(`/api/maps/layers/columns`, {
        params: { table: getTableReference(layer) }
    })).data.data;

    showLabelSetupDialog.value = true;
};

const updateLabelProp = (prop, value) => {
    if (currentLabelLayer.value) {
        currentLabelLayer.value.set(prop, value);
        updateLayerStyle(currentLabelLayer.value);
    }
};

const updateLayerStyle = (layer) => {
    const labelField = layer.get('labelField') || 'NONE';
    const labelColor = layer.get('labelColor') || '#000000';
    const labelSize = layer.get('labelSize') || 12;
    const labelFont = layer.get('labelFont') || 'Arial';

    if (layer instanceof VectorLayer) {
        const baseStyle = layer.get('_baseStyleForLabels') || layer.getStyle();
        layer.set('_baseStyleForLabels', baseStyle);

        layer.setStyle(generateLayerStyle(
            baseStyle,
            labelField,
            labelColor,
            labelSize,
            labelFont
        ));

        layer.changed();
    }
};

const getLayerOrderKey = (layer) => String(layer?.get?.('id') ?? layer?.ol_uid)

const getModuleLayers = (selectedModule) => {
    const selectedLayers = modules.value[selectedModule] || []
    const savedOrder = moduleViewOrders.value[selectedModule] || []

    if (!savedOrder.length) return selectedLayers

    const orderMap = new Map(savedOrder.map((key, index) => [key, index]))

    return selectedLayers.slice().sort((layerA, layerB) => {
        const indexA = orderMap.get(getLayerOrderKey(layerA))
        const indexB = orderMap.get(getLayerOrderKey(layerB))

        if (indexA === undefined && indexB === undefined) return 0
        if (indexA === undefined) return 1
        if (indexB === undefined) return -1

        return indexA - indexB
    })
}

const getDesiredLayers = (selectedModule) => {
    const selectedLayers = getModuleLayers(selectedModule)

    const otherVisibleLayers = Object.entries(modules.value)
        .filter(([name]) => name !== selectedModule)
        .flatMap(([_, layers]) => layers.filter(layer => layer.getVisible()))

    const desiredLayers = [...selectedLayers, ...otherVisibleLayers]
    const savedOrder = moduleViewOrders.value[selectedModule] || []

    if (!savedOrder.length) return desiredLayers

    const orderMap = new Map(savedOrder.map((key, index) => [key, index]))

    return desiredLayers.slice().sort((layerA, layerB) => {
        const indexA = orderMap.get(getLayerOrderKey(layerA))
        const indexB = orderMap.get(getLayerOrderKey(layerB))

        if (indexA === undefined && indexB === undefined) return 0
        if (indexA === undefined) return 1
        if (indexB === undefined) return -1

        return indexA - indexB
    })
}

const reorderModulesByConfig = (configModules) => {
    const reorderedModules = {}

    Object.entries(modules.value).forEach(([moduleName, currentLayers]) => {
        const configLayers = configModules[moduleName] || []
        const orderMap = new Map(
            configLayers
                .filter(layer => layer.id !== undefined && layer.id !== null)
                .map((layer, index) => [String(layer.id), index])
        )

        reorderedModules[moduleName] = currentLayers
            .map((layer, index) => ({ layer, index }))
            .sort((itemA, itemB) => {
                const orderA = orderMap.get(String(itemA.layer.get('id')))
                const orderB = orderMap.get(String(itemB.layer.get('id')))

                if (orderA === undefined && orderB === undefined) return itemA.index - itemB.index
                if (orderA === undefined) return 1
                if (orderB === undefined) return -1

                return orderA - orderB
            })
            .map(item => item.layer)
    })

    modules.value = reorderedModules
}

const getConfigModules = (configModules) => {
    return Object.fromEntries(
        Object.entries(configModules || {}).filter(([moduleName, layers]) => {
            return moduleName !== 'moduleViewOrders' && moduleName !== '__moduleViewOrders' && Array.isArray(layers)
        })
    )
}

const moveLayer = (index, direction) => {
    const selectedModule = moduleSelected.value || 'Padrão'
    const displayedLayers = getDesiredLayers(selectedModule)
    const layer = displayedLayers[index]
    if (!layer) return

    const newIndex = direction === 'up' ? index - 1 : index + 1

    if (newIndex < 0 || newIndex >= displayedLayers.length) return

    const [item] = displayedLayers.splice(index, 1)
    displayedLayers.splice(newIndex, 0, item)

    const selectedModuleLayers = modules.value[selectedModule] || []
    const reorderedSelectedLayers = displayedLayers.filter(displayedLayer => selectedModuleLayers.includes(displayedLayer))

    modules.value = { ...modules.value, [selectedModule]: reorderedSelectedLayers }

    moduleViewOrders.value = { ...moduleViewOrders.value, [selectedModule]: displayedLayers.map(getLayerOrderKey) }

    syncMapLayers()
    emitLayerData()
}

const moveLayerToTop = (layer) => {
    if (!layer) return;

    const collection = props.map.getLayers();

    if (collection.getArray().includes(layer)) {
        collection.remove(layer);
    }

    props.map.addLayer(layer);
};

const syncMapLayers = (nextDesiredLayers = null) => {
    const selectedModule = moduleSelected.value || 'Padrão'
    const desiredLayers = nextDesiredLayers || getDesiredLayers(selectedModule)
    registerLayerStateListeners(desiredLayers, refreshLayerList)

    const allModuleLayers = new Set(Object.values(modules.value).flat())
    const preservedHiddenLayers = hiddenLayers.value.filter(
        (layer) => layer && layer !== basemapLayer && !isBaseMapLayer(layer)
    )

    const collection = props.map.getLayers()

    collection.getArray().slice().forEach(layer => {
        if (isBaseMapLayer(layer) || allModuleLayers.has(layer) || preservedHiddenLayers.includes(layer)) {
            collection.remove(layer)
        }
    })

    collection.insertAt(0, basemapLayer)
    ensureRasterLayersOnMap()
    preservedHiddenLayers.forEach(layer => {
        if (!collection.getArray().includes(layer)) props.map.addLayer(layer)
    })
    desiredLayers.slice().reverse().forEach(layer => {
        if (!collection.getArray().includes(layer)) props.map.addLayer(layer)
    })

    mapLayers.value = [...desiredLayers]

    applyLayerStacking(desiredLayers)

    moveLayerToTop(documentLayer.value);
    moveLayerToTop(imagesLayer.value);

    requestMapRender()
}

const layerRegistrationContext = {
    moduleSelected,
    modules,
    moduleViewOrders,
    getDesiredLayers,
    syncMapLayers,
    emitLayerData,
    getLayerOrderKey,
    refreshLayerList,
}

const refreshDisplayedLayers = () => {
    const selectedModule = moduleSelected.value || 'Padrão'
    const desiredLayers = getDesiredLayers(selectedModule)

    mapLayers.value = [...desiredLayers]
    applyLayerStacking(desiredLayers)
    requestMapRender()
}

const applyParamsRecursive = (layersCollection, paramsById) => {
    layersCollection.getArray().forEach(layer => {
        const id = layer?.get?.('id');
        if (id != null) {
            const param = paramsById.get(id);
            if (param) {
                if (param.visible !== undefined) layer.setVisible(param.visible);
                if (param.opacity !== undefined) layer.setOpacity(param.opacity);
            }
        }

        if (layer instanceof LayerGroup || (layer && typeof layer.getLayers === 'function')) {
            applyParamsRecursive(layer.getLayers(), paramsById);
        }
    });
};

watch(
    () => props.layerSwitcherData?.updateKey,
    () => {
        const newValue = props.layerSwitcherData

        if (!newValue?.modules) return

        applyBaseMap(newValue.baseLayer === undefined ? basemapSelected.value : newValue.baseLayer)

        const configModules = getConfigModules(newValue.modules)

        moduleSelected.value = newValue.moduleSelected || 'Padrão'
        moduleViewOrders.value = newValue.modules.moduleViewOrders || newValue.modules.__moduleViewOrders || {}
        reorderModulesByConfig(configModules)

        const savedRasterSelection = Array.isArray(newValue.rasterLayersSelected)
            ? newValue.rasterLayersSelected
            : newValue.modules?.rasterConfig?.selectedIds || newValue.modules?.__rasterConfig?.selectedIds

        if (Array.isArray(savedRasterSelection)) {
            const selectedRasterIds = savedRasterSelection.map(String)

            rasterLayersSelected.value = rasterLayerInstances.value
                .map(layer => layer.get('id'))
                .filter(id => selectedRasterIds.includes(String(id)))

            rasterLayerInstances.value.forEach(layer => {
                layer.setVisible(selectedRasterIds.includes(String(layer.get('id'))))
            })
        }

        const layersArray = Object.values(configModules).flat()

        const paramsById = new Map(
            layersArray.filter(layer => layer.id !== undefined && layer.id !== null).map(layer => [String(layer.id), layer])
        )

        Object.values(modules.value)
            .flat()
            .forEach(layer => {
                const config = paramsById.get(String(layer.get('id')))

                if (!config) return

                if (config.visible !== undefined) {
                    const visible =
                        config.visible === true ||
                        config.visible === 1 ||
                        config.visible === '1' ||
                        config.visible === 'true'

                    layer.setVisible(visible)
                }

                if (config.opacity !== undefined) {
                    layer.setOpacity(Number(config.opacity))
                }

                if (config.zIndex !== undefined) {
                    layer.setZIndex(Number(config.zIndex))
                }

                layer.changed()
            })

        syncMapLayers()
    }
)

onMounted(async () => {
    updateMapViewportSize();

    addLayerToSwitcherListener = (event) => {
        const layer = event?.layer;
        if (!layer) return;

        const targetModule = String(event?.moduleName || layer.get?.('layerSwitcherGroup') || moduleSelected.value || 'Padrão').trim() || 'Padrão';
        const nextModuleLayers = (modules.value[targetModule] || []).filter(item => item !== layer);

        layer.set?.('displayInLayerSwitcher', true);
        layer.set?.('layerSwitcherGroup', targetModule);
        registerLayerStateListeners([layer]);

        if (event?.position === 'bottom') {
            nextModuleLayers.push(layer);
        } else {
            nextModuleLayers.unshift(layer);
        }

        modules.value = { ...modules.value, [targetModule]: nextModuleLayers };
        mapLayers.value = [...getDesiredLayers(moduleSelected.value || 'Padrão')];
        applyLayerStacking(mapLayers.value);
        emitLayerData();
        requestMapRender();
    };

    removeLayerFromSwitcherListener = (event) => {
        const layer = event?.layer;
        if (!layer) return;

        modules.value = Object.fromEntries(
            Object.entries(modules.value || {}).map(([moduleName, currentLayers]) => [
                moduleName,
                currentLayers.filter(item => item !== layer),
            ])
        );
        mapLayers.value = mapLayers.value.filter(item => item !== layer);
        emitLayerData();
        requestMapRender();
    };

    props.map?.on?.('map-layer-switcher:add-layer', addLayerToSwitcherListener);
    props.map?.on?.('map-layer-switcher:remove-layer', removeLayerFromSwitcherListener);

    const targetElement = props.map?.getTargetElement?.();
    if (targetElement && typeof ResizeObserver !== 'undefined') {
        mapResizeObserver = new ResizeObserver(() => {
            updateMapViewportSize();
        });
        mapResizeObserver.observe(targetElement);
    }

    const modulesMap = new Map([['Padrão', []]]);
    const rasterEntries = [];
    const rasterEntryIndexByName = new Map();
    hiddenLayers.value = [];

    baseLayerInfo.value = (await window.axios.get(`/api/maps/modules/get-module`, {
        params: { path: window.location.pathname }
    })).data.data
    applyBaseMap(baseLayerInfo.value.basemapSource, props.defaultBaseMap);

    const ensureModule = (moduleName) => {
        const normalizedModuleName = String(moduleName || 'Padrão').trim() || 'Padrão';
        if (!modulesMap.has(normalizedModuleName)) {
            modulesMap.set(normalizedModuleName, []);
        }
        return modulesMap.get(normalizedModuleName);
    };

    const pushLayerToModule = (moduleName, layer) => {
        ensureModule(moduleName).push(layer);
    };

    props.map.getLayers().getArray().forEach(layer => {
        if (!!layer.get('is_raster')) {
            layer.set('displayInLayerSwitcher', false);
            const entry = {
                label: layer.get('name') || 'Camada sem nome',
                value: layer.get('id'),
                data: layer
            };
            const normalizedName = normalizeLayerName(entry.label);
            const existingIndex = rasterEntryIndexByName.get(normalizedName);

            if (existingIndex === undefined) {
                rasterEntryIndexByName.set(normalizedName, rasterEntries.length);
                rasterEntries.push(entry);
            } else if (shouldPreferLayer(rasterEntries[existingIndex].data, layer)) {
                rasterEntries[existingIndex] = entry;
            }
            return;
        }

        if (!!layer.getLayers) {
            const groupLayers = [];
            const groupTitle = layer.get('title') || 'Padrão';

            layer.getLayers().getArray().forEach(subLayer => {
                if (subLayer.get('displayInLayerSwitcher')) {
                    subLayer.set('layerSwitcherGroup', groupTitle);
                    groupLayers.push(subLayer);
                }
            });

            ensureModule(groupTitle).push(...buildUniqueLayerList(groupLayers).reverse());
        } else {
            if (layer.get('name') === 'Documentos') {
                documentLayer.value = layer;
            } else if (layer.get('name') === 'Imagens') {
                imagesLayer.value = layer;
            } else if (layer.get('displayInLayerSwitcher')) {
                pushLayerToModule(layer.get('layerSwitcherGroup') || 'Padrão', layer);
            } else if (!isBaseMapLayer(layer)) {
                hiddenLayers.value.push(layer);
            }
        }
    })

    let baseModules = Array.from(modulesMap.entries()).map(([name, layers]) => ({
        name,
        layers: buildUniqueLayerList(layers),
    }))

    const nonDefaultLayerKeys = new Set(
        baseModules
            .filter(module => module.name !== 'Padrão')
            .flatMap(module => module.layers.map(getLayerIdentityKey))
    );

    baseModules = baseModules.map((module) => {
        if (module.name !== 'Padrão') return module;

        return {
            ...module,
            layers: module.layers.filter(layer => !nonDefaultLayerKeys.has(getLayerIdentityKey(layer))),
        };
    })

    baseModules = baseModules.filter(module => module.layers.length > 0)

    if (baseModules.length === 0) {
        baseModules = [{ name: 'Padrão', layers: [] }];
    }

    rasterEntries.sort((entryA, entryB) => {
        const orderA = Number(entryA.data.get('order') ?? 0);
        const orderB = Number(entryB.data.get('order') ?? 0);

        return orderA - orderB;
    });

    rasterLayers.value = rasterEntries;
    rasterLayerInstances.value = rasterEntries.map(entry => entry.data);
    rasterLayersSelected.value = rasterEntries
        .filter(entry => entry.data.getVisible())
        .map(entry => entry.value);

    props.map.getLayers().clear();

    const padrao = baseModules.shift();

    const nextModules = {}
    nextModules[padrao.name] = padrao.layers.reverse();

    baseModules.reverse().forEach(module => {
        nextModules[module.name] = module.layers.reverse()
    })

    modules.value = nextModules;
    registerLayerStateListeners(Object.values(nextModules).flat(), refreshLayerList);

    moduleSelected.value = padrao.name;

    mapLayers.value = [...modules.value[padrao.name]];

    emitLayerData();

    syncMapLayers();
})

onUnmounted(() => {
    if (addLayerToSwitcherListener) {
        props.map?.un?.('map-layer-switcher:add-layer', addLayerToSwitcherListener);
        addLayerToSwitcherListener = null;
    }
    if (removeLayerFromSwitcherListener) {
        props.map?.un?.('map-layer-switcher:remove-layer', removeLayerFromSwitcherListener);
        removeLayerFromSwitcherListener = null;
    }

    mapResizeObserver?.disconnect?.();
    mapResizeObserver = null;
})
</script>

<style scoped>

.floating-menu-container { position: absolute; z-index: 1000; background-color: rgba(255, 255, 255, 0.95); border-radius: 8px; box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3); display: flex; flex-direction: column; transition: all 0.3s ease; }

.right-menu { position: absolute; gap: 8px; top: 30px; right: 15px; z-index: 1000; }
.right-menu.collapsed-panel { width: 45px; }
.right-menu .menu-header { border-radius: 8px; justify-content: space-between; font-size: 14px; font-weight: bold; }
.right-menu:not(.collapsed-panel) .menu-header { border-radius: 8px 8px 0 0; }

.menu-content { display: flex; flex-direction: column; align-items: center; gap: 8px; max-height: 80vh; overflow-y: auto; overflow-x: hidden; transition: max-height 0.3s ease, padding 0.3s ease, opacity 0.3s ease; }
.right-menu .menu-content { align-items: stretch; }
.collapsed-panel .menu-content { max-height: 0 !important; padding: 0 !important; opacity: 0; overflow: hidden; border: none; }

.btn-info { background-color: #17a2b8 !important; }
.btn-info:hover { background-color: #138496 !important; }
.btn-dark { background-color: #343a40; }
.btn-dark:hover { background-color: #23272b !important; }
.btn-warning { background-color: #ffc107 !important; color: #000 !important; }
.btn-warning:hover { background-color: #e0a800 !important; }
.btn-active, :deep(.btn-active) { background-color: #28a745 !important; color: white !important; border-color: #28a745 !important; box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.3) !important; }
.btn-active:hover, :deep(.btn-active):hover { background-color: #1d7932 !important; color: white !important; border-color: #145423 !important; box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.3) !important; }
.btn-success { background-color: #28a745 !important; }
.btn-success:hover { background-color: #218838 !important; }
.btn-disabled { opacity: 0.3 !important; background-color: #6c757d !important; color: #fff !important; border-color: #6c757d !important; }

.basemap-selector { background: #e9ecef; padding: 10px; border-radius: 5px; margin-bottom: 10px; }
.basemap-selector label { font-size: 12px; font-weight: bold; color: #333; display: block; margin-bottom: 5px; text-align: center; }
.basemap-selector select { width: 100%; padding: 6px; border-radius: 4px; border: 1px solid #ccc; font-size: 12px; }

.layers-list-container { min-height: 0; }

.layer-item { width: 100%; display: flex; flex-direction: row; padding: 0; justify-content: space-around; background: #f8f9fa; margin-bottom: 8px; border-radius: 5px; border-left: 4px solid #007bff; font-size: 12px; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); transition: 0.3s ease; }
.layer-item.dirty { border-left-color: #dc3545; background-color: #fff5f5; }
.layer-item-top { display: flex; flex-direction: column; padding: 8px; justify-content: space-between; align-items: start; width: 100%; }
.layer-item-top button { width: 22px; height: 22px; padding: 0; font-size: 10px; border-radius: 3px; }
.layer-item input[type="text"] { border: none; background: transparent; font-weight: bold; width: 110px; font-size: 12px; }
.layer-item input[type="text"]:focus { background: #fff; border-bottom: 1px solid #007bff; outline: none; }

.layer-actions { display: flex; gap: 2px; }

.table-container { overflow: auto; max-height: 55vh; margin-top: 10px; border: 1px solid #eee; }
table { width: 100%; border-collapse: collapse; font-size: 12px; }
th, td { border: 1px solid #ddd; padding: 6px; text-align: left; white-space: nowrap; }
th { background-color: #f4f4f4; position: sticky; top: 0; z-index: 2; }
.tr-filter th { top: 28px; background-color: #e9ecef; z-index: 3; padding: 4px; }
.col-filter-input { width: 100%; padding: 4px; box-sizing: border-box; border: 1px solid #ccc; border-radius: 3px; font-size: 11px; }
tr:nth-child(even) { background-color: #f9f9f9; }
tr:hover { background-color: #f1f1f1; }
</style>
